var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      ref: _vm.dialogRef,
      staticClass: "playlists",
      attrs: { id: "general-form-wrapper", "md-click-outside-to-close": true }
    },
    [
      _c("md-dialog-content"),
      _c(
        "loader",
        { attrs: { loading: _vm.loading, size: 45 } },
        [
          _c(
            "md-dialog-actions",
            { staticClass: "actions" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-primary md-raised button",
                  on: { click: _vm.closeDialog }
                },
                [_vm._v("X")]
              )
            ],
            1
          ),
          _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.videoName))]),
          _vm.playlists.length > 0 ||
          _vm.tags.length > 0 ||
          _vm.serieName !== null
            ? _c("md-dialog-title", { staticClass: "md-headline" }, [
                _c("div", { staticClass: "moreInfo" }, [
                  _c("p", [
                    _c("strong", [_vm._v("Account:")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          this.account !== null ? this.account.name : "N/A"
                        )
                    )
                  ]),
                  _c("p", [
                    _c("strong", [_vm._v("Series name: ")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          this.serieName !== null ? this.serieName.name : "N/A"
                        )
                    )
                  ]),
                  _c("p", [
                    _c("strong", [_vm._v("Season: ")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          this.seasonNumber !== null ? this.seasonNumber : "N/A"
                        )
                    )
                  ]),
                  _c("p", [
                    _c("strong", [_vm._v("Episode: ")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          this.episodeNumber !== null
                            ? this.episodeNumber
                            : "N/A"
                        )
                    )
                  ]),
                  _c("p", [
                    _c("strong", [_vm._v("Duration: ")]),
                    _vm._v(" " + _vm._s(this.duration))
                  ]),
                  _vm.playlists.length > 0
                    ? _c(
                        "p",
                        [
                          _c("strong", [_vm._v("Playlists:")]),
                          _vm._v(" "),
                          _vm._l(_vm.playlists.join(", "), function(playlist) {
                            return _c("span", [_vm._v(_vm._s(playlist))])
                          })
                        ],
                        2
                      )
                    : _c("p", [
                        _c("strong", [_vm._v("Playlists:")]),
                        _vm._v(" N/A")
                      ]),
                  _vm.tags.length > 0
                    ? _c(
                        "p",
                        [
                          _c("strong", [_vm._v("Tags: ")]),
                          _vm._l(_vm.tags.join(", "), function(tag) {
                            return _c("span", [_vm._v(_vm._s(tag))])
                          })
                        ],
                        2
                      )
                    : _c("p", [
                        _c("strong", [_vm._v("Tags: ")]),
                        _vm._v(" N/A")
                      ]),
                  _vm.licenses.length > 0
                    ? _c(
                        "p",
                        [
                          _c("strong", [_vm._v("Licenses: ")]),
                          _vm._l(_vm.licenses.join(", "), function(license) {
                            return _c("span", [_vm._v(_vm._s(license))])
                          })
                        ],
                        2
                      )
                    : _c("p", [
                        _c("strong", [_vm._v("Licenses: ")]),
                        _vm._v(" N/A")
                      ])
                ])
              ])
            : _c("md-layout", { attrs: { "md-align": "center" } }, [
                _c(
                  "span",
                  { staticClass: "md-subheading", attrs: { id: "no-results" } },
                  [
                    _c("md-icon", {
                      staticClass: "md-accent",
                      attrs: { "md-iconset": "fa fa-exclamation-circle" }
                    }),
                    _vm._v(" No items to show")
                  ],
                  1
                )
              ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-600d9810", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-600d9810","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/mediaItem/AssociatedDialog.vue
// module id = 898
// module chunks = 0